import { decisioningStudioAgentsAppGroupIdDsaIdConstraints } from "../decisioningStudioAgentsAppGroupIdDsaIdConstraints";
import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/constraints/:component";

/** Mutations on a single component's constraint invalidate the collection
 *  GET /constraints cache (which the DataTable consumes). They also
 *  invalidate this endpoint's own per-component GET so a re-read after a
 *  PUT/DELETE reflects the new state. */
export const decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentCacheKeys: AllRouteEndpoints[] = [
  decisioningStudioAgentsAppGroupIdDsaIdConstraints,
  decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent,
];
